<td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-fg-primary">
  {{ projectName }}
</td>
<td class="px-6 py-4 whitespace-nowrap text-sm text-fg-secondary">
  {{ totalMinutes | formatMinutes }}
</td>
<td class="px-6 py-4 whitespace-nowrap text-sm text-fg-secondary">
  {{ billableMinutes | formatMinutes }}
</td>
<td class="px-6 py-4 whitespace-nowrap text-sm text-fg-secondary">
  {{ unbillableMinutes | formatMinutes }}
</td>
